import type { IndustryOnePagerConfig, Section } from '../copy';
import { SHARED_HERO } from '../copy';

const SECTIONS: Section[] = [
  {
    heading: 'Model your site in 3D',
    body: [
      {
        spans: [
          { text: 'unimoBuild', strong: true },
          {
            text: ' lets you model an outdoor or indoor site in minutes. No modelling skills required, just talk to it.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'Our maps are accurate and include the local topography, so you’re working with the real ground, not a guess.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'It can import from sources you already use: KMLs from Google Earth, PDFs, screenshots, photos. You can also export site layouts to PDF for setting out on the day.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'Either way you get an accurate, living 3D model that makes event planning, crowd flow design and rehearsal easy.',
          },
        ],
      },
    ],
  },
  {
    heading: 'Watch it live',
    body: [
      {
        spans: [
          { text: 'Forget juggling lots of other apps. The ' },
          { text: 'unimoLive', strong: true },
          {
            text: ' hub speaks to every kind of IoT sensor: existing ones, new ones, any make. It lays their readings over a map of your site or your ',
          },
          { text: 'unimoBuild', strong: true },
          { text: ' twin. One screen, in real time, with no fuss.' },
        ],
      },
      {
        spans: [
          {
            text: 'Get wind speed warnings from local sensors and week-ahead forecasts to plan around the weather.',
          },
        ],
      },
      {
        spans: [
          { text: 'Our solar-powered ' },
          { text: 'unimoEars', strong: true },
          {
            text: ' sound sensors work anywhere, including in nearby residential areas, mapping sound levels on and off site so you can evidence licence compliance if you’re ever challenged.',
          },
        ],
      },
    ],
  },
  {
    heading: 'Report on anything, anytime',
    body: [
      {
        spans: [
          { text: 'No spreadsheets to wrestle, no pivot tables to maintain. ' },
          { text: 'unimoReport', strong: true },
          { text: ' turns the stream of data ' },
          { text: 'unimoLive', strong: true },
          {
            text: ' captures into clear answers, onsite, in seconds. Plus you can hand it your event plans, site licences, risk assessments and production schedules so it understands the context behind the numbers.',
          },
        ],
      },
      {
        spans: [
          {
            text: 'It exports to Excel too. Just in case anyone on the team genuinely enjoys pivot tables.',
          },
        ],
      },
    ],
  },
];

export const eventsConfig: IndustryOnePagerConfig = {
  slug: 'events',
  route: '/events/one-pager',
  meta: {
    title: 'unimo for events: Model, watch, and report on your site.',
    description:
      'Model, watch, and report on your event site. Crowd density, sound, weather, queue lengths. Just ask.',
  },
  hero: SHARED_HERO,
  sections: SECTIONS,
  illustration: { src: '/assets/one-pager/events/illustration.svg' },
  pdfDownloadPath: '/downloads/unimo-events-one-pager.pdf',
};
